const SAMSUNG_INTERNET_REGEX = /SAMSUNG|Samsung|SGH-[I|N|T]|GT-[I|N]|SM-[A|N|P|T|Z]|SHV-E|SCH-[I|J|R|S]|SPH-L/i;

const useIsSamsungInternet = () => {
  return !!navigator.userAgent.match(SAMSUNG_INTERNET_REGEX);
};

export default useIsSamsungInternet;
